import React, { useContext, useEffect, useState } from 'react';
import { Card, Button, Tabs, Tab } from 'react-bootstrap';
import { Context } from '..';
import { observer } from 'mobx-react-lite';
import Calendar from '../components/Calendar';
import { useNavigate } from 'react-router-dom';
import { HISTORIC_BUILDINGS_ROUTE } from '../utils/consts';
import { fetchHistoricBuildings } from '../http/resourcesServicesAPI';
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const HistoricBuildings = observer(() => {
    const { resourcesServices } = useContext(Context);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchHistoricBuildings()
            .then((data) => {
                resourcesServices.setHistoricBuildings(data);
            })
            .finally(() => setLoading(false));
    }, []);
    if (loading) {
        return (
            <div className="d-flex align-items-center justify-content-center py-5">
                <Spinner animation={'grow'} />
            </div>
        );
    }
    return (
        <div className="d-flex flex-xl-row flex-column justify-content-center px-xl-4 px-2">
            <div className="py-4 px-5 border-bottom col-md-9">
                <div className="block-title pb-4">
                    <span>Servicii Speciale</span>
                </div>

                <div className="d-flex flex-row flex-wrap align-items-center justify-content-around">
                    {resourcesServices.historicBuildings.count > 0
                        ? resourcesServices.historicBuildings.rows.map((item, idx) => {
                              return (
                                  <Card key={idx} style={{ width: '22rem' }} className="my-3">
                                      {item.img ? (
                                          <Card.Img variant="top" src={process.env.REACT_APP_API_URL + item.img} />
                                      ) : null}

                                      <Card.Body>
                                          <Card.Title className="mb-3 d-flex align-items-center justify-content-between">
                                              <span
                                                  className="border border-primary rounded text-primary p-2"
                                                  style={{ fontSize: '1rem' }}
                                              >
                                                  {item.date}
                                              </span>
                                          </Card.Title>
                                          <Card.Text>
                                              <Link
                                                  to={HISTORIC_BUILDINGS_ROUTE + '/' + item.id}
                                                  className="text-decoration-none"
                                              >
                                                  <h3 className="text-primary cursor-pointer">{item.title}</h3>
                                              </Link>
                                          </Card.Text>
                                      </Card.Body>
                                  </Card>
                              );
                          })
                        : null}
                </div>
            </div>
            <Calendar />
        </div>
    );
});

export default HistoricBuildings;
